import { Builder, IBuilder } from 'builder-pattern';

export interface RoundReactionInterface {
  id: number;
  roundUUID: string;
  userID: number;
  emoji: string;
  username: string;
  createdAt: Date;
}

export namespace RoundReactionInterface {
  export function builder(
    template?: Partial<RoundReactionInterface>
  ): IBuilder<RoundReactionInterface> {
    return Builder<RoundReactionInterface>(template)
      .createdAt(template?.createdAt ?? new Date());
  }
}